import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Button, Form, FormGroup, Input, Label } from "@/design-system/native";
import { toast } from "react-toastify";
import { useAuth } from "../../../app/AuthProvider";
import styles from "./SignIn.module.scss";

/**
 * Login sayfası (Faz 6).
 *
 * - react-hook-form ile kontrolsüz form (manuel useState'ler kaldırıldı)
 * - useAuth() üzerinden adapter-agnostic giriş (Mock/Jwt swap)
 * - Hardcoded test credential pre-fill kaldırıldı (güvenlik); dev'de açıklayıcı not gösterilir
 */

const SignIn = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // Demo deploy — mock auth her credential'i kabul ediyor; production'da
  // da pre-fill + hint görünsün ki ziyaretçi tek tıkla login olabilsin.
  const { register, handleSubmit } = useForm({
    defaultValues: { email: "test@gmail.com", password: "test123" },
  });

  const onSubmit = async ({ email, password }) => {
    setSubmitting(true);
    try {
      await signIn(email, password);
      toast.success("Giriş başarılı.");
      navigate("/");
    } catch (err) {
      toast.error(err?.message || "Giriş başarısız.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.row}>
        <div className={styles.formCol}>
          <div className={styles.formWrap}>
            <div className={styles.header}>
              <img src="/logo5122.png" alt="Logo" className={styles.logo} />
              <p className={styles.lead}>
                İş akışınızı kolaylaştırmak, projeleri yönetmek ve ekibinizle etkili
                bir ekip çalışması yapmak için giriş yapın.
              </p>
              <small className={styles.demoHint}>
                Demo: <code>test@gmail.com</code> / <code>test123</code>
              </small>
            </div>
            <Form onSubmit={handleSubmit(onSubmit)} noValidate>
              <FormGroup>
                <Label for="email" className="visually-hidden">E-posta</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="E-posta adresiniz"
                  {...register("email")}
                />
              </FormGroup>
              <FormGroup>
                <Label for="password" className="visually-hidden">Şifre</Label>
                <Input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Şifre"
                  {...register("password")}
                />
                <Button
                  type="button"
                  color="link"
                  className={styles.toggleBtn}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  {showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                </Button>
              </FormGroup>
              <Button
                type="submit"
                disabled={submitting}
                className={styles.submitBtn}
              >
                {submitting ? "Giriş yapılıyor…" : "Giriş yap"}
              </Button>
              <div className={styles.forgotRow}>
                <a href="#" className={styles.forgotLink}>
                  Şifrenizi mi unuttunuz?
                </a>
              </div>
            </Form>
          </div>
        </div>

        <div className={styles.heroCol}>
          <div className={styles.heroStack}>
            <div className={styles.heroRow}>
              <img
                src="https://app.digitalexchangeai.com/assets/images/persons/person9.png"
                className={`${styles.heroImg} ${styles.heroImgTopLeft40}`}
                alt="hero-1"
              />
              <img
                src="https://app.digitalexchangeai.com/assets/images/persons/person1.png"
                className={`${styles.heroImg} ${styles.heroImgCircle}`}
                alt="hero-2"
              />
            </div>
            <div className={styles.heroRow}>
              <img
                src="https://app.digitalexchangeai.com/assets/images/persons/person7.png"
                className={`${styles.heroImg} ${styles.heroImgLeft30}`}
                alt="hero-3"
              />
              <img
                src="https://app.digitalexchangeai.com/assets/images/persons/person6.png"
                className={`${styles.heroImg} ${styles.heroImgFan30}`}
                alt="hero-4"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
